<template>
  <section>
    <TicketsScheduledSummary />

    <div class="display-flex-space-btw mb-5">
      <p class="is-blue page-title">Upcoming activities</p>
      <router-link :to="{ name: 'upcoming-activities' }">
        <span class="is-light-purple link">See all</span>
      </router-link>
    </div>

    <UpcomingActivities
      empty-state-title="No activities scheduled for today"
      showTodayOnly
      :max-number-to-show="4"
    />

    <!-- Shortcuts: as many per row as fit -->
    <div class="widgets mt-5 mb-5">
      <router-link
        class="widget"
        :to="{ name: 'manage-guiders' }"
      >
        <RouteButtonWithIcon
          title="Manage guiders"
          description="See their information and payment history."
        >
          <template v-slot:icon>
            <b-icon pack="fas" icon="users-cog"></b-icon>
          </template>
        </RouteButtonWithIcon>
      </router-link>

      <router-link
        class="widget"
        :to="{ name: 'manage-activities' }"
      >
        <RouteButtonWithIcon
          title="Manage activities"
          description="Create, edit and hide activities."
        >
          <template v-slot:icon>
            <b-icon pack="fas" icon="th-list"></b-icon>
          </template>
        </RouteButtonWithIcon>
      </router-link>

      <router-link
        class="widget"
        :to="{ name: 'affiliates-program' }"
      >
        <RouteButtonWithIcon
          title="Affiliates program"
          description="Manage affiliates."
        >
          <template v-slot:icon>
            <b-icon pack="fas" icon="user-tag"></b-icon>
          </template>
        </RouteButtonWithIcon>
      </router-link>

      <router-link class="widget" :to="{ name: 'admin-guide-requests' }">
        <RouteButtonWithIcon
          title="Guide requests"
          description="Post private guide jobs, compare offers and pay invoices."
        >
          <template v-slot:icon>
            <b-icon pack="fas" icon="hand-holding-usd"></b-icon>
          </template>
        </RouteButtonWithIcon>
      </router-link>

      <router-link class="widget" :to="{ name: 'admin-private-guides' }">
        <RouteButtonWithIcon
          title="Private guides"
          description="Approve guides and see their prices and history."
        >
          <template v-slot:icon>
            <b-icon pack="fas" icon="id-badge"></b-icon>
          </template>
        </RouteButtonWithIcon>
      </router-link>

      <div
        class="widget"
        @click="toggleModal(true)"
      >
        <RouteButtonWithIcon
          title="Generate code"
          description="Generate new codes to allow companies to register to the platform."
        >
          <template v-slot:icon>
            <b-icon pack="fas" icon="magic"></b-icon>
          </template>
        </RouteButtonWithIcon>
      </div>
    </div>

    <b-modal v-model="isCodeGenerationModalActive">
      <GenerateGuiderRegistrationCode @toggleModal="toggleModal" />
    </b-modal>
  </section>
</template>

<script>
import RouteButtonWithIcon from "../components/elements/RouteButtonWithIcon.vue";
import UpcomingActivities from "./UpcomingActivities.vue";
import GenerateGuiderRegistrationCode from "./GenerateGuiderRegistrationCode.vue";
import TicketsScheduledSummary from "./components/TicketsScheduledSummary.vue";
import { HelpersMixin } from "../mixins";

export default {
  mixins: [HelpersMixin],
  data() {
    return {
      isCodeGenerationModalActive: false,
    };
  },
  components: {
    UpcomingActivities,
    RouteButtonWithIcon,
    GenerateGuiderRegistrationCode,
    TicketsScheduledSummary,
  },
  methods: {
    toggleModal(isActive) {
      this.isCodeGenerationModalActive = isActive;
    },
  },
};
</script>

<style scoped lang="scss">
.pass-counter {
  display: flex;
  justify-content: center;
}

.g-card {
  border-radius: 12px;
  padding: 20px;
  background: linear-gradient(135deg, #f0f9ff, #e0f2fe);
  max-width: 400px;
  width: 100%;
}

.g-card h2 {
  font-size: 1.2rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #0f172a;
}

.widgets {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
  gap: 1rem;
}

.widget {
  display: block;
  min-width: 0;
  cursor: pointer;
}

::v-deep {
  .modal-close {
    right: 36px;
    top: 36px;
  }
}
</style>